import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DrawCollapseDirectiveSharedModule } from '@shared/core/directives/drawCollapse/draw-collapse.directive.shared.module';

import { PoweredByModule } from '@shared/core/components/poweredBy';

import { FooterComponent } from './footer.shared.component';

@NgModule({
    declarations: [
        FooterComponent,
    ],
    imports: [
        CommonModule,
        PoweredByModule,
        DrawCollapseDirectiveSharedModule,
    ],
    exports: [
        FooterComponent,
    ],
})
export class FooterModule {
}
